<template>
  <div class="fill-height bg-grey">
    <MainTopbar>
      <template v-slot:extension>
        <slot name="extension" />
      </template>
    </MainTopbar>

    <v-main>
      <v-container class="customWidth">
        <slot />
      </v-container>
    </v-main>

    <MainBottomNavigation
      class="hidden-md-and-up"
    />
  </div>
</template>

<style scoped lang="scss">
  .bg-grey {
    background: $grey-bg;
  }
</style>

<script>
import MainBottomNavigation from '@/components/navigation/MainBottomNavigation.vue';
import MainTopbar from '@/components/navigation/MainTopbar.vue';

export default {
  name: 'MainLayout',
  components: {
    MainBottomNavigation,
    MainTopbar,
  },
};
</script>
